import { css, cx } from '@repo/pandacss/styled-system/css';
import { button } from '@repo/pandacss/styled-system/recipes';
import type { ComponentType } from 'react';

export type SummaryTableSeeMoreAccountsButtonProps = {
  label: string;
  Icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  fullWidth?: boolean;
};

const containerClass = css({
  display: 'flex',
  paddingTop: '11',
  justifyContent: 'center',
});

const buttonWidthFull = css({ width: 'full' });

const buttonWidthResponsive = css({ width: { base: 'full', md: 'fit' } });

const iconClass = css({ fontSize: 'md', color: '[inherit]', verticalAlign: 'middle' });

export function SummaryTableSeeMoreAccountsButton({
  label,
  Icon,
  onClick,
  fullWidth = false,
}: SummaryTableSeeMoreAccountsButtonProps) {
  return (
    <div className={containerClass}>
      <button
        type="button"
        onClick={onClick}
        className={cx(
          button({ variant: 'showMoreButton' }),
          fullWidth ? buttonWidthFull : buttonWidthResponsive,
        )}
      >
        {label}
        <Icon className={iconClass} />
      </button>
    </div>
  );
}
